import React from "react";
import {
  COACH_COMPONENT_TEMPLATES_LIBRARY_CHECKIN_ROUTE,
  COACH_COMPONENT_TEMPLATES_LIBRARY_HABIT_ROUTE,
  COACH_COMPONENT_TEMPLATES_LIBRARY_LESSON_ROUTE,
  COACH_COMPONENT_TEMPLATES_LIBRARY_WORKOUT_ROUTE,
  COACH_GROUPS_ACTIVE_ROUTE,
  COACH_GROUPS_ARCHIVED_ROUTE,
} from "../routes/routes";
import { ComponentType, GroupStatus } from "../constants";

export const getAfter = (
  perPage: number,
  currentPage: number,
  key = "arrayconnection",
) =>
  currentPage > 1
    ? btoa(
        unescape(
          encodeURIComponent(`${key}:${perPage * (currentPage - 1) - 1}`),
        ),
      )
    : null;

export const perPage = 5;

export const getStatusFromPath = (path: string) => {
  switch (path) {
    case COACH_GROUPS_ACTIVE_ROUTE:
      return GroupStatus.ACTIVE;
    case COACH_GROUPS_ARCHIVED_ROUTE:
      return GroupStatus.ARCHIVED;

    default:
      return GroupStatus.ACTIVE;
  }
};

export const getComponentTypeFromPath = (path: string) => {
  switch (path) {
    case COACH_COMPONENT_TEMPLATES_LIBRARY_WORKOUT_ROUTE:
      return ComponentType.WORKOUT;
    case COACH_COMPONENT_TEMPLATES_LIBRARY_CHECKIN_ROUTE:
      return ComponentType.CHECKIN;
    case COACH_COMPONENT_TEMPLATES_LIBRARY_HABIT_ROUTE:
      return ComponentType.HABIT;
    case COACH_COMPONENT_TEMPLATES_LIBRARY_LESSON_ROUTE:
      return ComponentType.LESSON;

    default:
      return ComponentType.WORKOUT;
  }
};

export const PaginationContext = React.createContext<any>(null);
